//- Benefits Dots Animation
let num = 0;
function timeoutDotsAnimation() {
    setTimeout(function () {
        const el = $('#benefits .benefits__item');
        // console.log('num', num);
        (num === 4) ? num = 1 : num++;

        el.removeClass('benefits__item--anim');
        $('#benefits .benefits__item[data-num=' + num + ']').addClass('benefits__item--anim');
        timeoutDotsAnimation();
    }, 3000);
}

if ($('#benefits').length > 0) {
    timeoutDotsAnimation();
}

if ($('#benefitsCarousel').length > 0) {
    $('#benefitsCarousel').slick({
        slidesToShow: 1,
        arrows: true,
        dots: true,
        speed: 700,
        fade: true,
        adaptiveHeight: false,
        centerMode: false,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: $('#arrowPrev'),
        nextArrow: $('#arrowNext'),
        appendDots: $("#dotsControl")
    });
}